var _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoHorizontal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    width: 256.62668,
    height: 78.559998,
    viewBox: "0 0 256.62668 78.559998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,78.56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 890.586,307.336 c 16.035,0 28.066,3.559 36.09,10.695 8.023,7.121 12.027,18.707 12.027,34.742 0,15.438 -4.004,26.661 -12.027,33.649 -8.024,6.973 -20.055,10.461 -36.09,10.461 h -76.637 v -89.547 z m 24.957,143.914 c 14.258,0 27.094,-2.309 38.523,-6.922 11.43,-4.598 21.239,-10.902 29.43,-18.922 8.149,-8.031 14.387,-17.308 18.704,-27.851 4.3,-10.547 6.46,-21.907 6.46,-34.082 0,-18.715 -3.95,-34.899 -11.812,-48.567 -7.871,-13.664 -20.719,-24.051 -38.539,-31.179 v -0.887 c 8.617,-2.387 15.738,-6.012 21.386,-10.918 5.641,-4.902 10.254,-10.699 13.813,-17.387 3.555,-6.683 6.152,-14.035 7.792,-22.055 1.63,-8.015 2.74,-16.039 3.34,-24.066 0.3,-5.039 0.59,-10.984 0.9,-17.805 0.29,-6.839 0.81,-13.812 1.55,-20.941 0.75,-7.129 1.94,-13.883 3.57,-20.277 1.62,-6.383 4.08,-11.805 7.36,-16.254 h -69.965 c -3.856,10.097 -6.227,22.117 -7.129,36.09 -0.887,13.953 -2.223,27.324 -4.012,40.101 -2.379,16.61 -7.418,28.789 -15.133,36.531 -7.746,7.707 -20.351,11.579 -37.883,11.579 H 813.949 V 133.137 H 744.012 V 451.25 h 171.531",
    style: {
      fill: "#44b1ae",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1198.23,309.566 c -7.58,8.305 -19.1,12.477 -34.53,12.477 -10.11,0 -18.49,-1.703 -25.19,-5.133 -6.67,-3.414 -12.02,-7.644 -16.03,-12.695 -4.01,-5.047 -6.83,-10.41 -8.46,-16.035 -1.65,-5.649 -2.61,-10.7 -2.9,-15.149 h 102.91 c -2.97,16.035 -8.23,28.215 -15.8,36.535 m -71.51,-121.187 c 9.5,-9.219 23.17,-13.809 40.98,-13.809 12.77,0 23.77,3.184 32.98,9.567 9.21,6.394 14.83,13.152 16.92,20.285 h 55.69 c -8.9,-27.629 -22.57,-47.379 -40.99,-59.27 -18.41,-11.875 -40.69,-17.812 -66.82,-17.812 -18.12,0 -34.47,2.894 -49.01,8.676 -14.56,5.804 -26.89,14.043 -36.98,24.742 -10.11,10.687 -17.9,23.453 -23.39,38.32 -5.51,14.832 -8.24,31.172 -8.24,49.016 0,17.199 2.82,33.246 8.46,48.101 5.65,14.852 13.66,27.688 24.05,38.543 10.41,10.828 22.8,19.379 37.21,25.614 14.41,6.242 30.36,9.367 47.9,9.367 19.59,0 36.68,-3.801 51.23,-11.371 14.55,-7.563 26.51,-17.754 35.86,-30.508 9.37,-12.781 16.11,-27.336 20.28,-43.672 4.16,-16.34 5.64,-33.422 4.45,-51.238 h -166.18 c 0.89,-20.492 6.1,-35.34 15.6,-44.551",
    style: {
      fill: "#44b1ae",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1379.77,133.137 H 1316.5 V 451.25 h 63.27 V 133.137",
    style: {
      fill: "#44b1ae",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1494.73,133.137 h -63.27 v 230.336 h 63.27 z m -63.27,318.113 h 63.27 v -52.137 h -63.27 v 52.137",
    style: {
      fill: "#44b1ae",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1683.86,309.566 c -7.58,8.305 -19.1,12.477 -34.53,12.477 -10.11,0 -18.49,-1.703 -25.19,-5.133 -6.68,-3.414 -12.03,-7.644 -16.03,-12.695 -4.01,-5.047 -6.83,-10.41 -8.46,-16.035 -1.65,-5.649 -2.61,-10.7 -2.9,-15.149 h 102.91 c -2.97,16.035 -8.23,28.215 -15.8,36.535 m -71.51,-121.187 c 9.5,-9.219 23.17,-13.809 40.98,-13.809 12.76,0 23.77,3.184 32.98,9.567 9.19,6.394 14.83,13.152 16.92,20.285 h 55.69 c -8.9,-27.629 -22.58,-47.379 -40.99,-59.27 -18.41,-11.875 -40.7,-17.812 -66.83,-17.812 -18.11,0 -34.46,2.894 -49,8.676 -14.56,5.804 -26.89,14.043 -36.98,24.742 -10.11,10.687 -17.91,23.453 -23.39,38.32 -5.51,14.832 -8.26,31.172 -8.26,49.016 0,17.199 2.84,33.246 8.48,48.101 5.63,14.852 13.65,27.688 24.05,38.543 10.4,10.828 22.8,19.379 37.21,25.614 14.4,6.242 30.36,9.367 47.89,9.367 19.6,0 36.69,-3.801 51.24,-11.371 14.55,-7.563 26.51,-17.754 35.86,-30.508 9.37,-12.781 16.11,-27.336 20.28,-43.672 4.16,-16.34 5.64,-33.422 4.45,-51.238 h -166.18 c 0.89,-20.492 6.08,-35.34 15.6,-44.551",
    style: {
      fill: "#44b1ae",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1776.29,321.141 v 42.328 h 37.86 v 17.828 c 0,20.492 6.4,37.266 19.17,50.34 12.76,13.066 32.08,19.609 57.93,19.609 5.62,0 11.27,-0.219 16.92,-0.664 5.63,-0.453 11.14,-0.828 16.48,-1.117 V 402.23 c -7.41,0.895 -15.14,1.34 -23.16,1.34 -8.63,0 -14.77,-2.007 -18.49,-6.023 -3.72,-4 -5.58,-10.758 -5.58,-20.254 v -13.824 h 43.68 v -42.328 h -43.68 V 133.133 h -63.27 v 188.008 h -37.86",
    style: {
      fill: "#44b1ae",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.602,0 H 120.559 C 53.9727,0 0,53.9766 0,120.559 v 348.046 c 0,66.583 53.9727,120.583 120.559,120.583 h 348.043 c 66.586,0 120.562,-54 120.562,-120.583 V 120.559 C 589.164,53.9766 535.188,0 468.602,0",
    style: {
      fill: "#44b1ae",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 294.578,73.6641 c -72.699,0 -143.383,25.75 -199.0428,72.4769 l 18.6918,22.257 c 50.429,-42.359 114.492,-65.675 180.351,-65.675 65.879,0 129.938,23.316 180.352,65.675 l 18.683,-22.257 C 437.969,99.4141 367.285,73.6641 294.578,73.6641",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 300.789,361.688 c 14.992,0 26.231,3.328 33.723,9.988 7.5,6.66 11.222,17.48 11.222,32.472 0,14.422 -3.722,24.907 -11.222,31.418 -7.492,6.52 -18.731,9.786 -33.723,9.786 h -71.605 v -83.664 z m 31.52,134.464 c 13.308,0 25.316,-2.16 36.004,-6.464 10.683,-4.29 19.843,-10.196 27.468,-17.684 7.629,-7.484 13.461,-16.18 17.481,-26.012 4.023,-9.867 6.043,-20.472 6.043,-31.855 0,-17.489 -3.676,-32.625 -11.035,-45.367 -7.36,-12.778 -19.356,-22.481 -36.016,-29.141 v -0.84 c 8.059,-2.226 14.726,-5.613 19.98,-10.211 5.278,-4.578 9.582,-9.984 12.922,-16.223 3.328,-6.242 5.746,-13.105 7.274,-20.605 1.539,-7.492 2.574,-14.977 3.125,-22.48 0.281,-4.723 0.55,-10.266 0.832,-16.649 0.289,-6.387 0.765,-12.898 1.453,-19.566 0.699,-6.66 1.812,-12.977 3.34,-18.946 1.515,-5.964 3.812,-11.027 6.867,-15.199 h -65.363 c -3.602,9.438 -5.817,20.676 -6.657,33.719 -0.843,13.055 -2.078,25.535 -3.754,37.469 -2.21,15.543 -6.933,26.914 -14.16,34.14 -7.195,7.211 -19.004,10.821 -35.367,10.821 H 237.391 V 198.91 h -65.356 v 297.242 h 160.274",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHorizontal);
export default __webpack_public_path__ + "static/media/logo-horizontal.4e22e2e9.svg";
export { ForwardRef as ReactComponent };